var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "category-chips" }, [
    _c(
      "div",
      { staticClass: "chip-row" },
      [
        _c(
          "div",
          {
            staticClass: "chip",
            class: { active: _vm.activeId === null },
            on: {
              click: function ($event) {
                return _vm.selectParent(null, null)
              },
            },
          },
          [_vm._v("全部")]
        ),
        _vm._l(_vm.categories, function (item) {
          return _c(
            "div",
            {
              key: item.id,
              staticClass: "chip",
              class: { active: _vm.activeId === item.id },
              on: {
                click: function ($event) {
                  return _vm.selectParent(item.id)
                },
              },
            },
            [_vm._v(_vm._s(item.name))]
          )
        }),
      ],
      2
    ),
    _vm.childChips.length
      ? _c(
          "div",
          { staticClass: "chip-row sub-row" },
          [
            _c(
              "div",
              {
                staticClass: "chip sub",
                class: {
                  active:
                    _vm.activeId === _vm.activeParentId &&
                    _vm.activeChildId === null,
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("select-child", {
                      parentId: _vm.activeParentId,
                      childId: null,
                    })
                  },
                },
              },
              [_vm._v("全部" + _vm._s(_vm.activeParentName))]
            ),
            _vm._l(_vm.childChips, function (child) {
              return _c(
                "div",
                {
                  key: child.id,
                  staticClass: "chip sub",
                  class: { active: _vm.activeChildId === child.id },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("select-child", {
                        parentId: _vm.activeParentId,
                        childId: child.id,
                      })
                    },
                  },
                },
                [_vm._v(_vm._s(child.name))]
              )
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }